var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { space, layout, compose } from 'styled-system';
const StyledLabel = styled.label `
  ${({ theme: { colors, font, space: muiSpace } }) => `
    color: ${colors['slate-5']};
    font-weight: bold;
    font-size: ${font.body.xs.size};
    line-height: ${font.body.xs.lineHeight};
    margin-bottom: ${muiSpace.xs};
    display: block;
  `}
  ${compose(space, layout)}
`;
const Label = React.forwardRef((_a, ref) => {
    var { htmlFor, children } = _a, rest = __rest(_a, ["htmlFor", "children"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledLabel, Object.assign({ "data-testid": "mui-label", htmlFor: htmlFor, ref: ref }, rest), children)));
});
export { Label };
//# sourceMappingURL=Label.js.map